/* Mama Bundle — email signup popup (replaces EmailPopup.tsx)
   Shows once per browser after a delay, posts to Klaviyo, reveals discount code. */
(function () {
  'use strict';
  var STORAGE_KEY = 'mb_email_popup_seen';
  var CODE_KEY = 'mb_discount_code';

  function subscribeToKlaviyo(email, key, listId) {
    if (!key || !listId) { return Promise.resolve(); }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('[data-email-popup]');
    if (!overlay) return;

    var delay = (parseInt(overlay.getAttribute('data-delay'), 10) || 30) * 1000;
    var code = overlay.getAttribute('data-code') || 'MAMA10';
    var klaviyoKey = overlay.getAttribute('data-klaviyo-key');
    var klaviyoList = overlay.getAttribute('data-klaviyo-list');

    var formStep = overlay.querySelector('[data-email-step-form]');
    var successStep = overlay.querySelector('[data-email-step-success]');
    var form = overlay.querySelector('[data-email-form]');
    var input = overlay.querySelector('[data-email-input]');
    var submitBtn = overlay.querySelector('[data-email-submit]');
    var copyBtn = overlay.querySelector('[data-email-copy]');

    function seen() {
      try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return false; }
    }
    function markSeen() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    function close() { overlay.classList.remove('is-open'); markSeen(); }

    if (!seen()) {
      setTimeout(function () { overlay.classList.add('is-open'); }, delay);
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelectorAll('[data-email-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = input ? input.value : '';
        if (!email) return;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
        subscribeToKlaviyo(email, klaviyoKey, klaviyoList)
          .catch(function (err) { console.error('Klaviyo subscribe error', err); })
          .then(function () {
            markSeen();
            try { localStorage.setItem(CODE_KEY, code); } catch (e) {}
            if (formStep) formStep.hidden = true;
            if (successStep) successStep.hidden = false;
          });
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2000);
          });
        }
      });
    }
  });
})();
